import React from 'react';
import TextLink from '@prisjakt/ui-text-link';
import { Title } from '../review-form';
import {
  Row,
  Column,
  Byline,
  Section,
  PropertyValue,
  PropertyName,
} from './styles';
import { Property, DataListProps } from './types';
import { Yes, No } from './components/colored-icon';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

function renderValue(property: Property) {
  const value = property.value!;
  switch (value.type) {
    case 'link':
      return (value.urls || []).map((url, index) => (
        <a
          key={`${url}-${index.toString()}`}
          href={url}
          target="_blank"
          rel="nofollow noopener noreferrer"
        >
          {url}
        </a>
      ));
    case 'boolean': {
      if (typeof value.value !== 'boolean') {
        return null;
      }
      return value.value ? <Yes /> : <No />;
    }
    default:
      return value.link ? (
        <TextLink
          to={value.link}
          onClick={() => {
            trackInternalNavigationClick({
              scope: InternalNavigationScope.PRODUCT_INFORMATION,
              nextPage: value.link!,
            });
          }}
        >
          {value.text}
        </TextLink>
      ) : (
        value.text
      );
  }
}

const renderList = (properties: Property[], inline = false) =>
  properties.map((property, index) => {
    const key = `${property.name}-${index.toString()}`;
    return (
      <Row inline={inline} key={key} role="listitem">
        <Column full={property.column?.full}>
          <PropertyName>{property.name}</PropertyName>
        </Column>
        <Column full={property.column?.full}>
          <PropertyValue>
            {property.value && renderValue(property)}
          </PropertyValue>
          {property.byline && (
            <Byline key={property.byline}>{property.byline}</Byline>
          )}
        </Column>
        {property.children && renderList(property.children, true)}
      </Row>
    );
  });

export const DataList = (props: DataListProps) => (
  <Section key={props.title} role="list">
    {props.title && <Title>{props.title}</Title>}
    {renderList(props.properties)}
  </Section>
);
